//Custom Imports
import { taskType } from "@reducers/actionTypes";
import {
  asyncNormalActionCreator,
  asyncActionCreator,
  actionCreator,
} from "./redux.action";

const getTodayDailyTasks = asyncNormalActionCreator(
  taskType.GET_TODAY_TASK_UPCOMING,
  taskType.GET_TODAY_TASK_SUCCESS,
  taskType.GET_TODAY_TASK_ERROR,
);

const getClTaskSummary = asyncActionCreator(
  taskType.GET_CL_TASK_SUMMARY_UPCOMING,
  taskType.GET_CL_TASK_SUMMARY_SUCCESS,
  taskType.GET_CL_TASK_SUMMARY_ERROR,
  taskType.GET_CL_TASK_SUMMARY_FETCHED,
);

const getAbandonedCartData = asyncActionCreator(
  taskType.ABANDONED_CART_UPCOMING,
  taskType.ABANDONED_CART_SUCCESS,
  taskType.ABANDONED_CART_ERROR,
  taskType.ABANDONED_CART_FETCHED,
);

const getAbandonedBusinessTips = asyncActionCreator(
  taskType.ABANDONED_CART_BUSINESS_UPCOMING,
  taskType.ABANDONED_CART_BUSINESS_SUCCESS,
  taskType.ABANDONED_CART_BUSINESS_ERROR,
  taskType.ABANDONED_CART_BUSINESS_FETCHED,
);

const getAbandonedFeedback = asyncActionCreator(
  taskType.GET_ABANDONED_FEEDBACK_UPCOMING,
  taskType.GET_ABANDONED_FEEDBACK_SUCCESS,
  taskType.GET_ABANDONED_FEEDBACK_ERROR,
  taskType.GET_ABANDONED_FEEDBACK_FETCHED,
);

const getWalletData = asyncActionCreator(
  taskType.GET_WALLET_DATA_TASK_UPCOMING,
  taskType.GET_WALLET_DATA_TASK_SUCCESS,
  taskType.GET_WALLET_DATA_TASK_ERROR,
  taskType.GET_WALLET_DATA_TASK_FETCHED,
);
const getWalletBusinessTips = asyncActionCreator(
  taskType.WALLET_BUSINESS_TIPS_UPCOMING,
  taskType.WALLET_BUSINESS_TIPS_SUCCESS,
  taskType.WALLET_BUSINESS_TIPS_ERROR,
  taskType.WALLET_BUSINESS_TIPS_FETCHED,
);
const getWalletFeedback = asyncActionCreator(
  taskType.GET_WALLET_FEEDBACK_UPCOMING,
  taskType.GET_WALLET_FEEDBACK_SUCCESS,
  taskType.GET_WALLET_FEEDBACK_ERROR,
  taskType.GET_WALLET_FEEDBACK_FETCHED,
);

const getPromotionBusinessTips = asyncActionCreator(
  taskType.PROMOTION_BUSINESS_TIPS_UPCOMING,
  taskType.PROMOTION_BUSINESS_TIPS_SUCCESS,
  taskType.PROMOTION_BUSINESS_TIPS_ERROR,
  taskType.PROMOTION_BUSINESS_TIPS_FETCHED,
);
const getPromotionData = asyncActionCreator(
  taskType.GET_PROMOTION_DATA_TASK_UPCOMING,
  taskType.GET_PROMOTION_DATA_TASK_SUCCESS,
  taskType.GET_PROMOTION_DATA_TASK_ERROR,
  taskType.GET_PROMOTION_DATA_TASK_FETCHED,
);

const showSnackbarClTask = actionCreator(taskType.SHOW_SNACKBAR_TASK);
const updateTaskLoading = actionCreator(taskType.CL_TASK_LOADING);
const updateSnackbarLoading = actionCreator(taskType.CL_SNACKBAR_LOADING);
const updateFireLoading = actionCreator(taskType.CL_FIRE_LOADING);

export default {
  getTodayDailyTasks,
  updateTaskLoading,
  getClTaskSummary,
  getAbandonedCartData,
  getAbandonedBusinessTips,
  getAbandonedFeedback,
  updateSnackbarLoading,
  updateFireLoading,
  showSnackbarClTask,
  getWalletData,
  getWalletBusinessTips,
  getWalletFeedback,
  getPromotionBusinessTips,
  getPromotionData,
};
